import { render, staticRenderFns } from "./CreateTemplateModal.vue?vue&type=template&id=462d43ce&"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462d43ce')) {
      api.createRecord('462d43ce', component.options)
    } else {
      api.reload('462d43ce', component.options)
    }
    module.hot.accept("./CreateTemplateModal.vue?vue&type=template&id=462d43ce&", function () {
      api.rerender('462d43ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/notifications/CreateTemplateModal.vue"
export default component.exports